// import worldCountries from "world-countries";

// export const COUNTRY_OPTIONS = worldCountries
//   .filter(
//     (country) => !!country.flag && country.name.common && country.idd.root
//   )
//   .map((country) => ({
//     name: country.name.common,
//     label: country.name.common,
//     value:
//       country.flag + " " + country.idd.root + country.idd.suffixes[0] || "",
//     flag: country.flag,
//     countryCode: country.idd.root + country.idd.suffixes[0] || "",
//   }));
import worldCountries from "world-countries";

export const COUNTRY_OPTIONS = worldCountries
  .filter(
    (country) =>
      !!country.flag &&
      country.name?.common &&
      country.idd?.root &&
      Array.isArray(country.idd.suffixes) &&
      country.idd.suffixes.length > 0
  )
  .map((country) => {
    const code = `${country.idd.root}${country.idd.suffixes[0]}`;
    return {
      name: country.name.common,
      label: country.name.common,
      value: `${country.flag} ${code}`,
      flag: country.flag,
      countryCode: code,
    };
  });
